module.exports = __webpack_public_path__ + "static/media/threeupshadow.c059e712.png";